import { render, staticRenderFns } from "./PartidaPresupuestalView.vue?vue&type=template&id=d8cba926&"
import script from "./PartidaPresupuestalView.vue?vue&type=script&lang=js&"
export * from "./PartidaPresupuestalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports